module.exports = __webpack_public_path__ + "static/media/conf.32100898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/conf.jpg
// module id = 1527
// module chunks = 0